/* Account -> Tickets list.
   Config and phone arrive as data-* attributes rendered by sections/ticket-page.liquid.
   This file used to contain `{{ customer.phone }}` directly, but .js assets are NOT
   Liquid-rendered: the literal braces survived, digit-stripped to an empty string, and
   the logged-in list never loaded. It also carried a hardcoded bearer token. */
document.addEventListener("DOMContentLoaded", function () {
  var box = document.getElementById("ticketsResults");
  if (!box) return;

  function esc(x) {
    return String(x == null ? "" : x).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  /* Only absolute http(s) links and same-site paths reach an href — the care API is
     treated as untrusted input, so javascript: URLs cannot get through. */
  function safeUrl(u) {
    u = String(u == null ? "" : u).trim();
    if (/^https?:\/\//i.test(u)) return esc(u);
    if (/^\/[^\/]/.test(u)) return esc(u);
    return "";
  }
  function show(html) { box.innerHTML = html; }
  function normPhone(v) {
    var d = String(v || "").replace(/\D/g, "");
    if (d.length > 10) d = d.slice(-10);
    return d.length === 10 ? d : "";
  }

  var params = new URLSearchParams(window.location.search);
  var fromUrl = params.get("phone_no");
  if (fromUrl) {
    var clean = new URL(window.location.href);
    clean.searchParams.delete("phone_no");
    window.history.replaceState({}, document.title, clean.toString());
  }
  /* The account's own phone wins; ?phone_no= is only a fallback for logged-out deep links.
     NOTE: the care API still accepts any phone with only a shared token — that has to be
     fixed server-side. This only stops the page preferring an attacker-supplied value. */
  var phone = normPhone(box.getAttribute("data-phone")) || normPhone(fromUrl);

  var base = (box.getAttribute("data-base") || "").replace(/\/+$/, "");
  var client = box.getAttribute("data-client") || "";
  var token = box.getAttribute("data-token") || "";

  if (!phone) { show('<p class="tck-empty">Log in to see your support tickets.</p>'); return; }
  if (!base || !token) { show('<p class="tck-empty">Ticket history isn’t available right now.</p>'); return; }

  show('<p class="tck-empty">Loading your tickets…</p>');

  fetch(base + "/" + encodeURIComponent(client) + "/tickets/" + encodeURIComponent(phone), {
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token }
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var list = (data && data.status === "success" && Array.isArray(data.data)) ? data.data : [];
      if (!list.length) { show('<p class="tck-empty">No tickets found.</p><p>You haven’t raised any support tickets yet. If you need help, please contact support.</p>'); return; }
      show(list.map(function (t) {
        var url = safeUrl(t.url);
        var issue = esc(t.issue || "Support request");
        var head = url
          ? '<a class="ticket-acc-issue" href="' + url + '" target="_blank" rel="noopener">' + issue + "</a>"
          : '<span class="ticket-acc-issue">' + issue + "</span>";
        var closed = String(t.status || "").toLowerCase().indexOf("close") > -1;
        return '<div class="ticket-card">' +
          '<p style="margin:0;line-height:normal;"><span class="tck-head">Issue: </span> ' + head + "</p>" +
          '<hr class="tck-hr">' +
          '<p class="tck-sts-p"><span class="tck-head">Status:</span> <span class="tck-status" style="color:' +
          (closed ? "#ec1a23" : "green") + ';">' + esc(t.status || "Open") + "</span></p>" +
          '<p class="tck-crt-p"><span class="tck-head">Created At:</span> <span class="tck_create">' +
          esc(t.created_at || "") + "</span></p>" +
          '<p class="tck-son-p"><span class="tck-head">Order no.:</span> <span class="tck_create">' +
          esc(t.shopify_order_no || "—") + "</span></p>" +
          (url ? '<p class="tck-url-p"><a class="ticket-acc-url" href="' + url + '" target="_blank" rel="noopener">View Ticket</a></p>' : "") +
          "</div>";
      }).join(""));
    })
    .catch(function () {
      /* Never render the raw error object — it used to go straight into innerHTML. */
      show('<p class="tck-empty" style="color:#b3261e;">We couldn’t load your tickets just now. Please refresh, or contact support.</p>');
    });
});
